export const GET_ACADEMIC_RECORDS = 'GET_ACADEMIC_RECORDS'
export const GET_ACADEMIC_RECORD_OPTIONS = 'GET_ACADEMIC_RECORD_OPTIONS'
export const CREATE_ACADEMIC_RECORD = 'CREATE_ACADEMIC_RECORD'
export const UPDATE_ACADEMIC_RECORD = 'UPDATE_ACADEMIC_RECORD'
export const DELETE_ACADEMIC_RECORD = 'DELETE_ACADEMIC_RECORD'
